import axios from 'axios'

const request = axios.create({
  // baseURL: 'http://192.168.0.109:8081',
  baseURL: 'https://drawnew.yiyutop.cn',
  timeout: 50000
})

request.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

export default request
